<template>
  <section class="hero">
    <div class="hero__media">
      <!-- A collage of tiles, so it's always shown whole at its own ratio
           rather than cropped to fit the column. -->
      <img
        :src="heroSmall"
        :srcset="`${heroSmall} 700w, ${heroLarge} 1374w`"
        sizes="(max-width: 960px) 100vw, 56vw"
        width="1374"
        height="1145"
        alt="Vintage paintings, a kilim rug and studio ceramics"
        fetchpriority="high"
      />
    </div>

    <div class="hero__content">
      <p class="eyebrow">Handmade · One of a kind</p>
      <h1 class="hero__heading">Real art doesn’t have to <em>cost a fortune.</em></h1>
      <p class="hero__body">Paintings, ceramics and rugs, each one a unique, handmade work of art. Never printed, always human.</p>
      <div class="hero__cta">
        <router-link to="/collections/new-arrivals" class="btn btn--dark">Shop New Arrivals</router-link>
        <router-link :to="{ path: '/', hash: '#our-story' }" class="hero__link">Our story</router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',

  data() {
    return {
      heroSmall: require('../../assets/images/hero-700.jpg'),
      heroLarge: require('../../assets/images/hero-1374.jpg'),
    }
  },
}
</script>

<style scoped>
.hero {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(0, 1fr);
  min-height: min(78vh, 76rem);
  max-width: var(--max-w);
  margin: 0 auto;
  padding: 4rem 4rem 0;
  gap: 6.4rem;
  align-items: center;
}

.hero__media {
  aspect-ratio: 1374 / 1145;
  background: var(--paper);
  overflow: hidden;
  animation: fade-in 1.1s ease backwards;
}

.hero__media img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Page-load fade: the image settles first, then the copy follows line by line. */
.hero__content > * { animation: fade-in-up 0.9s cubic-bezier(0.2, 0.7, 0.2, 1) backwards; }
.hero__content > :nth-child(1) { animation-delay: 0.25s; }
.hero__content > :nth-child(2) { animation-delay: 0.4s; }
.hero__content > :nth-child(3) { animation-delay: 0.55s; }
.hero__content > :nth-child(4) { animation-delay: 0.7s; }

.hero__content {
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  padding: 4rem 0;
}

.hero__heading {
  font-size: clamp(4.2rem, 5.6vw, 7.6rem);
  font-weight: 400;
  line-height: 1.02;
  letter-spacing: -0.01em;
}

.hero__heading em { color: var(--amber); }

.hero__body {
  font-size: 1.7rem;
  font-weight: 300;
  line-height: 1.65;
  color: var(--charcoal);
  max-width: 42rem;
}

.hero__cta {
  display: flex;
  align-items: center;
  gap: 2.8rem;
  flex-wrap: wrap;
  padding-top: 0.8rem;
}

.hero__link {
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--ink);
  border-bottom: 1px solid var(--ink);
  padding-bottom: 2px;
}
.hero__link:hover { color: var(--amber); border-color: var(--amber); }

@media (prefers-reduced-motion: reduce) {
  .hero__media, .hero__content > * { animation: none; }
}

@media (max-width: 960px) {
  .hero {
    grid-template-columns: 1fr;
    min-height: 0;
    padding: 1.6rem 1.6rem 0;
    gap: 0;
  }

  .hero__content { padding: 3.2rem 0 1.6rem; }
}
</style>
